export enum ActionTypes {
    getUser = "getUser",
    tryRefreshToken = "tryRefreshToken",
    getToken = "getToken",
    getRecaptchaStatus = "getRecaptchaStatus",
    socketSendMessage = "socketSendMessage"
}